// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2CUhh","active":"NavigationItem_active__25Nhy"};